<script lang="ts">
  import type { schema } from "@editor/schema";
  import Block from "./Block.svelte";
  import { getNewsletterStores } from "../newsletterStores";
  import { isEditor, LinkContent, photoToCTA, fancyPicClassIfNoCTA } from "./utils";

  const { ctx } = getNewsletterStores();

  export let block: schema.ImageBlock;
</script>

<Block bind:block on:click on:delete on:duplicate size="full" let:isEmpty layouts={["lg"]}>
  {#if isEmpty}
    {#if block._defaults}
      <div class="">
        {#if block._defaults.photo}<img
            src={block._defaults.photo.legacy_thumb_url}
            class="h-full w-full"
            alt={"big photo placeholder"} />{/if}
      </div>
    {:else}
      <div class="p-2">
        <div class="flex h-64 items-center justify-center rounded-lg border-2 border-dashed border-gray-400 bg-gray-100 text-gray-600">
          <div class="flex flex-col items-center text-center">
            <div>
              <span class="material-icons-round notranslate text-6xl text-gray-500">add_a_photo</span>
            </div>
            <div>
              <h1 class="text-15">Click to add a photo</h1>
              <p class="mt-1 text-13">We support JPEG, PNG and GIFs</p>
            </div>
          </div>
        </div>
      </div>
    {/if}
  {:else if block.photo}
    <div class="group relative w-full">
      <LinkContent
        let:isLink
        cta={block.photo.cta ? photoToCTA(block.photo) : undefined}
        type="photo"
        data-title={block.photo.title}
        class="skip-tracking relative block h-full w-full  {fancyPicClassIfNoCTA(block.photo)}"
        data-img-full={block.photo.legacy_full_url}
        linkText={block.photo.alt_text || block.photo.title}
        aria-label={block.photo.alt_text}>
        <img
          aria-hidden={isLink}
          src={block.photo.legacy_thumb_url}
          alt={block.photo.alt_text || "User uploaded image"}
          title={block.photo.alt_text}
          loading="lazy"
          class="max-h-full w-full max-w-full bg-transparent object-contain" />
      </LinkContent>
      {#if !isEditor()}
        <div
          class="absolute left-0 right-0 top-0 flex items-center justify-end gap-x-1.5 p-1.5 opacity-0 group-hover:opacity-100"
          aria-hidden="true">
          {#if block.photo.cta?.url && block.photo.cta?.url.length}
            <LinkContent
              role="presentation"
              tabindex="-1"
              cta={block.photo.cta ? photoToCTA(block.photo) : undefined}
              type="photo"
              data-title={block.photo.title}
              class="skip-tracking material-icons notranslate relative flex rounded bg-nxgray-700 bg-opacity-80 p-1 text-lg text-white"
              data-img-full={block.photo.legacy_full_url}
              linkText={block.photo.alt_text || block.photo.title}
              aria-hidden="true"
              aria-label="Open image in new tab">
              open_in_new
            </LinkContent>
          {/if}
          <a
            class="fancy-pic skip-tracking focusable material-icons notranslate rounded bg-nxgray-700 bg-opacity-80 p-1 text-18 text-white"
            tabindex="-1"
            href={block.photo.legacy_full_url}
            aria-hidden="true"
            aria-label="Show image in original size">
            zoom_out_map
            <span class="sr-only">Show in original size</span>
          </a>
        </div>
      {/if}
    </div>
  {/if}
</Block>

<style>
  img {
    max-height: 550px;
    object-fit: contain;
  }
  .fancy-pic {
    position: relative !important;
    display: flex !important;
  }
</style>
